import React from 'react'
import { Grid, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import Labels from './../../../../common/Labels'
import momentDateAndTime from './../../../../../helpers/momentDateAndTime';
import DaysDifference from './../../Drive/cards/DaysDifference';
import DailyUpdateCheckBox from '../../Drive/cards/DailyUpdateCheckBox';
@source({
    mouseEnter: (props) => {
        dispatch.app.setHelpContext('Schedule Card')
    }
})

class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contingency: 0,
            endDate: '',
            contingencyChanged: false
        }
    }

    render() {
        return (
            <Grid className="setlabel" >
                <Grid.Row style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                    <Grid.Column>
                        <Labels
                            name="Timezone"
                            text={this.props.selectedDataById.timeZone} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                    <Grid.Column width={5}>
                        <Labels
                            name="Start Date"
                            text={momentDateAndTime(this.props.selectedDataById.startDate)} />
                        <Labels
                            name="Estimated End Date"
                            text={momentDateAndTime(this.props.selectedDataById.endDate)} />
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <Labels
                            name="Total Days"
                            text={this.props.selectedDataById.totaldays} />
                        <Labels
                            name="Contingency / Holidays"
                            text={this.props.selectedDataById.contingency === 0 ? "0" : this.props.selectedDataById.contingency} />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Labels
                            name="Days"
                            text={
                                <DaysDifference
                                    startDate={this.props.selectedDataById.startDate}
                                    endDate={this.props.selectedDataById.endDate}
                                    totaldays={this.props.selectedDataById.totaldays}
                                    timeZone={this.props.selectedDataById.timeZone}
                                    activeTab={this.props.activeTab}
                                    isInitiativeStarted={this.props.selectedDataById.actualStartDate ? true : false}
                                    workingDays={this.props.selectedDataById.workingDays}
                                />
                            } />
                        <Labels
                            name="Working Days"
                            text={
                                <div className="days_buttons" >
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[0] ? "bg-blue" : ""}`} disabled >Su</Button>
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[1] ? "bg-blue" : ""}`} disabled >Mo</Button>
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[2] ? "bg-blue" : ""}`} disabled >Tu</Button>
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[3] ? "bg-blue" : ""}`} disabled >We</Button>
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[4] ? "bg-blue" : ""}`} disabled >Th</Button>
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[5] ? "bg-blue" : ""}`} disabled >Fr</Button>
                                    <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[6] ? "bg-blue" : ""}`} disabled >Sa</Button>
                                </div>
                            } />
                    </Grid.Column>
                    <Grid.Column width={16}>
                        {this.props.selectedDataById && <DailyUpdateCheckBox id={this.props.selectedDataById._id} dailyUpdates={this.props.selectedDataById.dailyUpdates} />}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

export default Schedule